module.exports = __webpack_public_path__ + "static/media/vzx.c6ac3272.jpg";